module.exports = __webpack_public_path__ + "img/电梯动画20.80d30647.png";